module.exports = __webpack_public_path__ + "img/img17.8be1c4f6.png";